// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D0Qh","colBig":"styles_colBig__Dmild","colSmall":"styles_colSmall__2wK5Z","shopifyNameWrapper":"styles_shopifyNameWrapper__3_aAN"};